'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSlider = function () {
  function ImageSlider(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ImageSlider);

    this.handleAddClass = function (event) {
      _this.active = true;
      _this.els.scrollerEl.classList.add('sec-ImageSlider_Scroller-scrolling');
    };

    this.handleRemoveClass = function (event) {
      _this.active = false;
      _this.els.scrollerEl.classList.remove('sec-ImageSlider_Scroller-scrolling');
    };

    var context = { context: el };

    this.els = {
      el: el,
      inputEl: (0, _functional.getElement)('.sec-ImageSlider_Input'),
      scrollerEl: (0, _functional.getElement)('.sec-ImageSlider_Scroller', context)
    };

    this.els.inputEl.addEventListener('input', function (e) {
      _this.els.el.style.setProperty('--Position', e.target.value / 10 + '%');
    });

    this.active = false;

    this.setupSlider();
  }

  (0, _createClass3.default)(ImageSlider, [{
    key: 'setupSlider',
    value: function setupSlider() {
      this.els.scrollerEl.addEventListener('mousedown', this.handleAddClass.bind(this));

      document.body.addEventListener('mouseup', this.handleRemoveClass.bind(this));

      document.body.addEventListener('mouseleave', this.handleRemoveClass.bind(this));

      this.els.scrollerEl.addEventListener('touchstart', this.handleAddClass.bind(this));

      document.body.addEventListener('touchend', this.handleRemoveClass.bind(this));

      var observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
      };

      function observerCallback(entries) {
        entries.forEach(function (entry) {
          var sliderContainer = (0, _functional.getElement)('.sec-ImageSlider_SlideContainer');
          if (entry.isIntersecting) {
            sliderContainer.style.setProperty('--PosTransition', '0.25s');
            entry.target.classList.add('sec-ImageSlider_SlideContainer-animate');
            setTimeout(function () {
              sliderContainer.style.setProperty('--PosTransition', '0s');
              sliderContainer.style.setProperty('--Position', '75%');
              entry.target.classList.remove('sec-ImageSlider_SlideContainer-animate');
            }, 1250);
          } else {
            sliderContainer.style.setProperty('--PosTransition', '0s');
            sliderContainer.style.setProperty('--Position', '75%');
            entry.target.classList.remove('sec-ImageSlider_SlideContainer-animate');
          }
        });
      }

      // eslint-disable-next-line compat/compat
      var observer = new IntersectionObserver(observerCallback, observerOptions);
      observer.observe(this.els.el);
    }
  }]);
  return ImageSlider;
}();

exports.default = ImageSlider;